import type { FC, SVGProps } from "react";

const IconWelcomeDrink: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M4 20H12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 9V20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 1L8 9L1 1H15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconWelcomeDrink;